import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=9094d79c&"
import script from "./DropFile.vue?vue&type=script&lang=ts&"
export * from "./DropFile.vue?vue&type=script&lang=ts&"
import style0 from "./DropFile.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports